import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';

export function HeroBlock({ heroBlock }: IPageFields) {
  const { sys, fields } = heroBlock ?? {};

  if (!heroBlock) {
    return null;
  }

  return (
    <div className="mb-20 tablet:mb-[120px]">
      <Blocks sys={sys} fields={fields} />
    </div>
  );
}
